/**
 * Formatação da Supervisão (spec 071): duração curta e a cor da espera. A cor
 * sai da MESMA regra do shared (attendanceWaitLevel), e o texto diz sempre o
 * número — a cor nunca é a única informação.
 */
import { attendanceWaitLevel, type AttendanceWaitLevel } from '@erp/shared';

/** segundos → "agora", "40 s", "12 min", "3h 20min", "2d 5h" */
export function formatSeconds(seconds: number | null): string {
  if (seconds === null) return '—';
  const s = Math.max(0, Math.round(seconds));
  if (s < 5) return 'agora';
  if (s < 60) return `${s} s`;
  if (s < 3600) return `${Math.floor(s / 60)} min`;
  if (s < 86_400) {
    const h = Math.floor(s / 3600);
    const m = Math.floor((s % 3600) / 60);
    return m === 0 ? `${h}h` : `${h}h ${m}min`;
  }
  const d = Math.floor(s / 86_400);
  const h = Math.floor((s % 86_400) / 3600);
  return h === 0 ? `${d}d` : `${d}d ${h}h`;
}

/** segundos desde um instante, no relógio do servidor (agora corrigido) */
export function secondsSince(at: Date | string | null, nowMs: number): number | null {
  if (at === null) return null;
  return Math.max(0, Math.round((nowMs - new Date(at).getTime()) / 1000));
}

export const LEVEL_TEXT: Record<AttendanceWaitLevel, string> = {
  ok: 'text-foreground',
  warn: 'text-[#D48806]',
  alert: 'text-[#CF1322]',
};

export const LEVEL_DOT: Record<AttendanceWaitLevel, string> = {
  ok: 'bg-[#52C41A]',
  warn: 'bg-[#FAAD14]',
  alert: 'bg-[#FF4D4F]',
};

export function waitLevel(seconds: number | null): AttendanceWaitLevel {
  return attendanceWaitLevel(seconds);
}

/** "08:15" (hora) ou "03/11 08:15" quando não é hoje */
export function formatWhen(at: Date | string | null, nowMs: number): string {
  if (at === null) return '—';
  const d = new Date(at);
  const today = new Date(nowMs).toDateString() === d.toDateString();
  const time = d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
  return today
    ? time
    : `${d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' })} ${time}`;
}
